import './Heart.css'

export default function Heart() {
  return <div className="frame">
  <div className="heart left"></div>
  <div className="heart right"></div>
  <div className="heart bottom"></div>
  </div>
}